import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {IconButton, makeStyles, Popover, Typography} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import listRequestWrapper from "../../../../Services/API/listRequestWrapper";
import InputAdornment from "@material-ui/core/InputAdornment";
import {FormDynamic} from "../FormDynamic";

const useStyles = makeStyles(() => ({
    adornmentEnd: {
        marginLeft: -30,
        paddingRight: 6
    }
}))

const MultiLngMenu = (props) => {
    const {value, apply, disabled, type, isArray, onOpenCallback} = props;
    const userLanguage = useSelector(state => state.app.userLanguage);
    const [userLocales, setUserLocales] = useState({});
    const [availableLng, setAvailableLng] = useState([]);
    const [anchor, setAnchor] = useState(null)
    const isOpen = Boolean(anchor);
    const classes = useStyles();
    useEffect(() => {
        if (!isOpen) return;
        getLanguages();
        setValue();
    }, [isOpen])

    async function getLanguages() {
        try {
            const languages = await listRequestWrapper('language');
            setAvailableLng(languages)
        } catch (e) {
            console.log(e)
        }
    }

    function onClose() {
        setAnchor(null)
        if (onOpenCallback) {
            onOpenCallback(false)
        }
    }

    function onOpen(e) {
        setAnchor(e.currentTarget)
        if (onOpenCallback) {
            onOpenCallback(true)
        }
    }

    function setValue() {
        if (Array.isArray(value)) {
            setUserLocales({[userLanguage]: value})
            return
        }
        if (typeof value === 'object') {
            setUserLocales(value)
            return;
        }
        if (typeof value === 'string') {
            setUserLocales({[userLanguage]: value})
        }
    }


    function onChangeComponent(value, path) {
        setUserLocales(prevState => {
            return {
                ...prevState,
                [path]: value
            }
        })
    }

    return (
        <>
            <InputAdornment
                position={'end'}
                classes={{positionEnd: classes.adornmentEnd}}
            >
                <IconButton size={"small"} onClick={onOpen}
                            disabled={disabled}
                >
                    <Typography color={"textSecondary"} variant={"body1"} style={{fontSize: '0.8rem'}}>
                        {userLanguage.toUpperCase()}
                    </Typography>
                </IconButton>
            </InputAdornment>

            <Popover
                anchorEl={anchor}
                open={isOpen}
                onClose={onClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                style={{
                    zIndex: 9999
                }}
            >
                <div style={{
                    display: 'flex', flexDirection: 'column', padding: 10,
                    width: type === 'textArea' ? '300px' : 'auto'
                }}>
                    {availableLng.map((lng, index) => (
                        <>
                            <FormDynamic
                                field={{
                                    isArray,
                                    label: lng.name,
                                    path: `${lng.id}`,
                                    type: type === 'textArea' ? 'text' : "string",
                                    autofocus: index === 0,
                                    max: 999
                                }}
                                fieldStyles={{
                                    fullWidth: true,
                                    presentation: "standard"
                                }}
                                setValue={onChangeComponent}
                                values={userLocales}
                            />
                            {/*<TextField variant={'standard'}*/}
                            {/*           key={uid(lng)}*/}
                            {/*           multiline={type === 'textArea'}*/}
                            {/*           size={"small"}*/}
                            {/*           value={userLocales[lng.id]}*/}
                            {/*           onChange={handleInput}*/}
                            {/*           label={lng.name}*/}
                            {/*           autoFocus={index === 0}*/}
                            {/*           name={lng.id}*/}
                            {/*/>*/}
                        </>
                    ))}
                    <div style={{padding: '5px 0', display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                        <Button
                            variant={'contained'} color={'primary'}
                            size={'small'}
                            onClick={() => {
                                apply(userLocales);
                                onClose();
                            }}
                        >Apply</Button>
                        <Button
                            onClick={onClose}
                            variant={'contained'} color={'default'} size={'small'}
                            style={{marginLeft: 5}}
                        >Cancel</Button>
                    </div>
                </div>
            </Popover>
        </>
    )
}
MultiLngMenu.propTypes = {
    anchor: PropTypes.object,
    onClose: PropTypes.func,
    disabled: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    apply: PropTypes.func,
    isArray: PropTypes.bool,
    onOpenCallback: PropTypes.func
}
export default MultiLngMenu;